class CollectionTemplateAnalyticsProcessor
{
    constructor(listName)
    {
        this.index = 0;
        this.listName = listName;
        this.#onLoaded();
    }

    #onLoaded() 
    {
        this.sendPageLoadedEvent(document);
    }

    sendPageLoadedEvent(doc)
    {
        var products = this.#getProductsFromGrid(doc);
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
                items: products
            },
        });
    }

    #getProductsFromGrid(doc) 
    {
        const productsElements = doc.querySelectorAll(".collectionBlock");
        const products = [];

        productsElements.forEach((element) => {
            this.index++;
            
            products.push({
                item_id: element.dataset.id,
                item_name: element.dataset.title,
                price: element.dataset.price / 100,
                item_brand: element.dataset.brand,
                item_category: element.dataset.category,
                item_list_name: this.listName,
                index: this.index,
                quantity: 1,
            });
        });

        return products;
    }
}